import { createAction } from '@reduxjs/toolkit';

export const globalActions = {
  resetStateAll: createAction<void>('resetStateAll'),
};
